import { toast, Slide } from 'react-toastify';

// Components
import Toast from './Toast';

/**
 * Hook to notify the user with a toast message
 * @returns {ToastHook} The hook with notify function
 */
const useToast = () => {
  /**
   * Notify the user with a toast message
   * @param {NotifyParams} params - The parameters of the function
   * @returns {void}
   */
  const notify = ({
    message = '',
    type = 'success',
    hasIcon = false,
    hasCross = false,
    autoClose = 2000,
    options = {},
  }) => {
    toast(
      <Toast
        type={type}
        hasIcon={hasIcon}
        hasCross={hasCross}
      >
        {message}
      </Toast>,
      {
        autoClose,
        closeOnClick: true,
        transition: Slide,
        ...options,
      },
    );
  };

  return {
    notify,
  };
};

export default useToast;
